import { PermitRoleSettings } from "./PermitRoleSettings";
import { PermitTypeRoleSettings } from "./PermitTypeRoleSettings";

export interface Role {
    id: string;
    clientId: string;
    name: string;
    permitRoleSettings: PermitRoleSettings;
    permissionKeys: string[];
    isArchived: boolean;
    permitTypeRoleSettings?: PermitTypeRoleSettings[];
}

export function getPermitRoleSettings(role: Role, permitTypeId?: string): PermitRoleSettings {
    if (permitTypeId) {
        const permitTypeRoleSettings = role.permitTypeRoleSettings?.find(
            (s) => s.permitType.id === permitTypeId
        );
        if (permitTypeRoleSettings) {
            return permitTypeRoleSettings.permitRoleSettings;
        }
    }
    return role.permitRoleSettings;
}
